import { defineStore } from 'pinia';
import { useIndexStore } from './IndexStore';
import CruiseService from '@/service/CruiseService';

// TODO - 29082024 - This store have to be cleanup
// this.vendorSelectedId does not exit?!
// The type of state members must be also reviewed
export const useCruiseStore = defineStore('cruiseStore', {
  state: () => ({
    cruises: {},
    vendors: {},
    ships: {},
    destinationsCruiseSelectedId: '',
    listVendorSelectedId: [],
    sailingSelectedId: '',
    shipSelectedId: '',
    destinationsCruise: [],
    retPortId: '',
    listSailing: [],
    lineId: '',
    shipId: '',
    sailingId: '',
    sailingByRequote: [],
    isLoading: false,
    retPortData: {},
    groupDestination: [],
    vendorById: [],
    lineById: {},
    filterDest: [],
    shipById: {},
    destById: {},
    listDestId: [],
    listDestRequote: []
  }),
  getters: {
    selectListDestRequote: (state) => state.listDestRequote,
    selectDestById: (state) => state.destById,
    selectShipById: (state) => state.shipById,
    selectFilterDest: (state) => state.filterDest,
    selectLineById: (state) => state.lineById,
    selectCruises: (state) => state.cruises,
    selectListVenDor: (state) => state.listVendorSelectedId,
    destinationsCruises: (state) => {
      if (state.destinationsCruise) {
        return state.destinationsCruise;
      }
    },
    selectGroupDestination: (state) => state.groupDestination,
    destinationsCruisesOrigin: (state) => {
      if (state.cruises.destinations) {
        const destinationsTemp = state.cruises.destinations.map((m) => {
          const temp = {
            label: m.name,
            items: m.kids?.map((k) => {
              const kid = {
                label: k.Name,
                value: k.ID
              };
              return kid;
            })
          };
          return temp;
        });
        return destinationsTemp;
      }
    },
    selectPort: (state) => state.retPortData,
    selectVendors: (state) => state.vendors,
    selectShips: (state) => state.ships,
    ports: (state) => {
      const portsTemp = state?.cruises?.ports?.filter((p) => {
        return p.PortID === +state.retPortId;
      });
      return portsTemp;
    },
    getListSailing: (state) => state.listSailing,
    selectLineId: (state) => {
      const lineTemp = state.cruises?.vendors?.filter((c) => {
        return c.id === +state.lineId;
      });
      return lineTemp;
    },
    selectShipId: (state) => {
      const shipTemp = state.cruises?.ships?.filter((s) => {
        return s.id === +state.shipId;
      });
      return shipTemp;
    },
    selectSailId: (state) => {
      return state.sailingByRequote;
    },
    doLoading: (state) => state.isLoading
  },
  actions: {
    async getCruise() {
      try {
        const cruiseService = new CruiseService();
        const res = await cruiseService.getCruiseInfo();
        this.updateCruise(res.data);
        this.updateDestinationsCruise(res.data);
        this.updateGroupDestination(res.data);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getVendors(payload, desId) {
      try {
        const cruiseService = new CruiseService();
        const res = await cruiseService.getVendors(payload, desId);
        this.updateVendors(res.data);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getNewVendors(payload) {
      try {
        const cruiseService = new CruiseService();
        const res = await cruiseService.getNewVendor(payload);
        this.updateVendors(res.data);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getShips(payload) {
      try {
        const cruiseService = new CruiseService();
        const res = await cruiseService.getShips(payload);
        this.updateShips(res.data);
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    async getRePortId(id) {
      try {
        const cruiseService = new CruiseService();
        const res = await cruiseService.getRetPortId(id);
        this.updateGetRePort(res.data);
        return res;
      } catch (e) {
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    updateGetRePort(payload) {
      this.retPortData = payload;
    },
    getSailingNameRequote(destId, lineId, shipId) {
      if (destId && lineId && shipId) {
        const sailTemp = this.cruises?.sailings?.filter((s) => +s.destId === destId && s.vendorId === lineId && +s.shipId === shipId);
        this.updateSailingRequote(sailTemp);
      }
    },
    updateCruise(payload) {
      this.cruises = payload;
    },
    updateVendors(payload) {
      this.vendors = payload;
    },
    updateShips(payload) {
      this.ships = payload;
    },
    updateGroupDestination(payload) {
      const destinationTemp = payload.map((m, index) => {
        const dest = {
          key: index,
          label: m.name,
          value: m.id,
          vendors: m.vendors,
          children: m?.kids?.map((k, indexK) => {
            const kid = {
              key: `${index}-${indexK}`,
              label: k.Name,
              value: k.ID,
              vendors: k.vendors,
              children: k?.grandKids?.map((g, indexG) => {
                const grandKid = {
                  key: `${index}-${indexK}-${indexG}`,
                  label: g.Name,
                  value: g.ID,
                  vendors: g.vendors
                };
                return grandKid;
              })
            };
            return kid;
          })
        };
        return dest;
      });
      this.groupDestination = destinationTemp;
    },
    updateDestinationsCruise(payload) {
      const destinationsTemp = payload.map((m) => {
        const temp = {
          label: m.name,
          items: m.kids?.map((k) => {
            const kid = {
              label: k.Name,
              value: k.ID
            };
            return kid;
          })
        };
        return temp;
      });
      this.destinationsCruise = destinationsTemp;
    },
    updateDestinationsCruiseChanged(payload) {
      this.destinationsCruise = payload;
    },
    updateDestinationsCruiseSelectedId(destinationsCruiseSelectedId) {
      this.destinationsCruiseSelectedId = destinationsCruiseSelectedId;
    },
    updateSailingSelectedId(sailingSelectedId) {
      this.sailingSelectedId = sailingSelectedId;
    },
    updateVendorIdRequote(listVendor, vendorId) {
      this.vendorSelectedId = vendorId;
      const uniqueShipId = listVendor.reduce((uniqueId, item) => {
        if (!uniqueId.includes(item.shipId)) {
          uniqueId.push(item.shipId);
        }
        return uniqueId;
      }, []);
      this.listVendorSelectedId = uniqueShipId;
    },
    updateVendorId(vendorId, selectId) {
      this.vendorSelectedId = selectId;
      const uniqueShipId = vendorId.value?.vendors?.reduce((uniqueId, item) => {
        if (!uniqueId.includes(item.shipId)) {
          uniqueId.push(item.shipId);
        }
        return uniqueId;
      }, []);
      this.listVendorSelectedId = uniqueShipId;
    },
    updateShipSelectedId(shipId) {
      this.shipSelectedId = shipId;
    },
    getReturnPortId(retPortId) {
      this.retPortId = retPortId;
    },
    updateDestId(destId) {
      const listDest = [];
      destId.forEach((dest) => {
        listDest.push(dest.destId);
        if (listDest) {
          this.listDestId = listDest;
        }
      });
    },
    setListSailing() {
      if (this.destinationsCruiseSelectedId && this.vendorSelectedId && this.shipSelectedId) {
        const cruiseService = new CruiseService();
        cruiseService.getCruiseSailing(this.destinationsCruiseSelectedId, this.vendorSelectedId, this.shipSelectedId)?.then((res) => {
          this.listSailing = res.data;
        });
      } else {
        this.listSailing = [];
      }
    },
    getNewSailing() {
      if (this.listDestId && this.vendorSelectedId && this.shipSelectedId) {
        const cruiseService = new CruiseService();
        cruiseService.getNewSailing(this.listDestId, this.vendorSelectedId, this.shipSelectedId)?.then((res) => {
          this.listSailing = res.data;
        });
      } else {
        this.listSailing = [];
      }
    },
    getLineNameRequote(destId) {
      const filter = this.cruises.filter((f) => f.id === destId);
      if (!filter.length) {
        this.cruises.forEach((cruise) => {
          cruise?.kids?.forEach((kid) => {
            if (kid.id === destId) {
              this.filterDest = kid;
            }
            kid?.grandKids?.forEach((grand) => {
              if (grand.id === destId) {
                this.filterDest = grand;
              }
            });
          });
        });
      } else {
        this.filterDest = filter;
      }
    },
    getVendorById(vendors, lineId) {
      this.lineById = vendors.filter((v) => v.id === lineId);
    },
    getShipNameRequote(id) {
      this.shipId = id;
    },
    updateSailingRequote(payload) {
      this.sailingByRequote = payload;
    },
    updateSailings() {
      if (this.destinationsCruiseSelectedId && this.vendorSelectedId && this.shipSelectedId) {
        const sailTemp = this.cruises.sailings.filter((s) => +s.destId === this.destinationsCruiseSelectedId && s.vendorId === this.vendorSelectedId && +s.shipId === this.shipSelectedId);
        this.listSailing = sailTemp;
      }
    },
    async syncData() {
      const Service = new CruiseService();
      try {
        this.isLoading = true;
        const res = await Service.syncData();
        if (res) {
          this.isLoading = false;
          return res.data;
        }
      } catch (e) {
        this.isLoading = false;
        const store = useIndexStore();
        store.updateNotification(e);
      }
    },
    getShipById(shipId) {
      this.shipById = this.ships.filter((s) => s.id === shipId);
    },
    getSailingById(destId, lineId, shipId) {
      this.updateDestId(destId);
      this.vendorSelectedId = lineId;
      this.shipSelectedId = shipId;
      this.getNewSailing();
    },
    formatDestination(destination, parent, isTest) {
      const payload = [];
      if (destination.key === this.destById.key || isTest) {
        const findDest = destination.key.includes(parent.key);

        if (findDest) {
          const formatDest = {
            destId: parent.value,
            vendorIds: parent.vendors
          };
          payload.push(formatDest);
          if (parent?.children) {
            parent?.children.map((c) => {
              const child = {
                destId: c.value,
                vendorIds: c.vendors
              };
              payload.push(child);
              if (c?.children) {
                c?.children?.map((gc) => {
                  const grandChild = {
                    destId: gc.value,
                    vendorIds: gc.vendors
                  };
                  payload.push(grandChild);
                });
              }
            });
          }
        }
      }
      return payload;
    },
    getDestinationCruise(destId) {
      const filter = this.groupDestination.filter((dest) => dest.value === destId);
      if (!filter.length) {
        this.groupDestination.forEach((f) => {
          f?.children?.forEach((c) => {
            if (c.value === destId) {
              this.destById = c;
            }
            c?.children?.forEach((gc) => {
              if (gc.value === destId) {
                this.destById = gc;
              }
            });
          });
        });
        let payload = [];
        this.groupDestination.forEach((g) => {
          g?.children?.forEach((c) => {
            payload = [...payload, ...this.formatDestination(c, g)];
            c?.children?.forEach((gc) => {
              payload = [...payload, ...this.formatDestination(gc, g)];
            });
            this.updateDestId(payload);
            this.listDestRequote = payload;
          });
        });
        return;
      }
      if (filter[0].value) {
        this.updateDestId(this.formatSubDestination(filter));
        this.destById = filter;
        this.listDestRequote = this.formatSubDestination(filter);
      }
    },
    formatSubDestination(destinations) {
      const payload = [];
      destinations.map((f) => {
        const formatDest = {
          destId: f.value,
          vendorIds: f.vendors
        };
        payload.push(formatDest);
        if (f?.children) {
          f?.children?.map((c) => {
            const child = {
              destId: c.value,
              vendorIds: c.vendors
            };
            payload.push(child);
            if (c?.children) {
              c?.children?.map((gc) => {
                const grandChild = {
                  destId: gc.value,
                  vendorIds: gc.vendors
                };
                payload.push(grandChild);
              });
            }
          });
        }
      });
      return payload;
    },
    initHotelData() {
      return {
        hotelName: '',
        rooms: [
          {
            room: ''
          }
        ]
      };
    }
  }
});
